import { all } from "redux-saga/effects";
import { mfaWatcher } from "./mfaSaga";

export default function* mfaSaga(action) {
    yield all([
        mfaWatcher(action)
    ]);
}
